import { FetchUser } from "./types/common/dto";
import { admin } from "@/utils/role";

export default function access(initialState: { currentUser?: FetchUser } | undefined) {
  const { currentUser } = initialState ?? {};
  return {
    isAdmin: currentUser ? currentUser.roles.includes(admin) : false,
  };
}
